module.exports = __webpack_public_path__ + "images/frontpage_stars@1x.png?cfc1ce92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_stars@1x.png
// module id = 663
// module chunks = 7